function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRockon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.38 35.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.38,14.97c.55,0,.8.4.56.9l-9.24,18.86c-.24.49-.89.9-1.44.9H1c-.55,0-1-.45-1-1V1C0,.45.45,0,1,0h7.8c.55,0,1,.45,1,1v25.13c0,.55.45,1,1,1h11.04c.55,0,1.2-.4,1.44-.9l.72-1.49c.24-.49-.01-.9-.56-.9h-7.56c-.55,0-.8-.4-.56-.9l3.43-7.07c.24-.49.89-.9,1.44-.9h20.2Zm-26.63,7.92c-.24.5-.88.9-1.43.9h-.42c-.55,0-1-.45-1-1v-13.49c0-.55.45-1,1-1h5.46c.55,0,1,.45,1,1v3.01c0,.55-.2,1.41-.43,1.9l-4.18,8.68Zm12.99-14.59c.55,0,1,.45,1,1v3.01c0,.55-.45,1-1,1h-6.24c-.55,0-1-.45-1-1v-3.01c0-.55.45-1,1-1h6.24Zm2.1-7.29c0-.55.45-1,1-1h7.84c.55,0,1,.45,1,1v11.3c0,.55-.45,1-1,1h-7.84c-.55,0-1-.45-1-1V1Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRockon);
export default __webpack_public_path__ + "static/media/rockon.405d2afec4a81587bb1b6204a6359704.svg";
export { ForwardRef as ReactComponent };